/** Norsk formatering av verdier i Compass-visninger (mellomrom som tusenskille, komma som desimaltegn). */
import type { KpiItemSpec } from './types';

const nb = (digits: number) =>
    new Intl.NumberFormat('nb-NO', { minimumFractionDigits: digits, maximumFractionDigits: digits });

export function formatDuration(seconds: number): string {
    const s = Math.round(seconds);
    if (s < 60) return `${s} s`;
    const m = Math.floor(s / 60);
    if (m < 60) return `${m} min ${s % 60 ? `${s % 60} s` : ''}`.trim();
    const h = Math.floor(m / 60);
    return `${h} t ${m % 60 ? `${m % 60} min` : ''}`.trim();
}

export function formatKpiValue(value: number | string | null, format?: KpiItemSpec['format']): string {
    if (value === null || value === undefined || value === '') return '–';
    if (typeof value !== 'number') return String(value);
    switch (format) {
        case 'integer': return nb(0).format(Math.round(value));
        case 'decimal1': return nb(1).format(value);
        case 'decimal2': return nb(2).format(value);
        case 'percent': return `${nb(1).format(value)} %`;
        case 'currency': return `${nb(0).format(value)} kr`;
        case 'duration_s': return formatDuration(value);
        case 'text': return String(value);
        default: return Number.isInteger(value) ? nb(0).format(value) : nb(2).format(value);
    }
}

/** Datoer fra API-et (ISO) vises som dd.mm.yyyy. */
export function formatDateLabel(value: unknown): string {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(value)) return value === null || value === undefined ? '' : String(value);
    const [y, m, d] = value.slice(0, 10).split('-');
    return `${d}.${m}.${y}`;
}
